// extracted by css-extract-rspack-plugin
export default {"Faq":"Faq-module__Faq__t6pJvD8"};